<template>
<div class="main">
    <header>{{data.subject}}</header>
    <div class="container">
        <div>
            <h2>您好，首次登陆</h2>
            <p>请正确填写您的微信昵称，获取直播课观看权限</p>
        </div>
        <div class="form-item">
            <div>
                <img src="@/assets/imgs/icon-user.png" alt="" srcset=""> <input v-model="form.name" type="text" name="" id="" placeholder="微信昵称">
            </div>
            <p v-if="form.err" class="err-info"><img src="@/assets/imgs/icon-warning.png" alt="" srcset="">请正确填写微信昵称</p>
        </div>
    </div>
    <div>
        <button @click="submit" class="btn">进入直播</button>
    </div>
</div>
</template>

<script>
// import Gohome from '@/components/gohome/gohome'
import {
    liveLogin,
    liveFiestPage
} from '@/model/live/serve'
export default {
    name: 'Live',
    data() {
        return {
            data: {
                subject: '标题',
                speakerInfo: "王老师BIM建模讲师",
                scheduleInfo: "xx直播课",
                description: ""
            },
            form: {
                name: '',
                err: false
            }
        }
    },
    components: {
        // Gohome
    },
    created() {
        liveFiestPage({
            liveId: this.$route.query.id
        }).then(res => {
            this.data = res.data
        })
    },
    methods: {
        goHome() {
            this.$router.push({
                path: '/',
            })
        },
        submit() {
            if (!this.form.name) {
                this.form.err = true
                return
            }
            liveLogin({
                wxName: this.form.name,
                liveId: this.$route.query.id
            }).then(res => {
                this.$router.push(`/livevideo?src=${encodeURIComponent(res.data.studenturl)}`)
            }).catch(data => {
                if (data.retuCode == 5004) {
                    this.$router.push(`/login?pathLogin=livelogin?id=${this.$route.query.id}`)
                    return
                }
                if (data.retuCode == 5018) {
                    this.$router.push(`/liveerror?id=${this.$route.query.id}`)
                    return
                }
            })
        }
    },

}
</script>

<style lang="less" scoped>
header {
    padding: 20px;
    box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.15);
    text-align: center;
}

.main {
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-content: space-between;
    background: #fff;
}

.container {
    margin-top: 20px;
    flex: 1;
    padding: 20px;
}

.btn {
    padding: 20px;
    width: 100%;
    background: #f08344;
    outline: none;
    border: none;
    text-decoration: none;
    color: #fff;
    box-shadow: 5px 3px 7px 3px rgba(0, 0, 0, 0.15);
    font-size: 18px;
}

p {
    font-size: 15px;
}

input {
    background-image: none;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 40px;
    outline: none;
    padding: 0 15px;
    transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
    width: 100%;
    font-size: 18px;
}

.form-item {
    margin-top: 62px;
}

.form-item div {
    border-bottom: 1px solid #F3F3F3;
    display: flex;
    align-items: center;
}

.form-item div img {
    width: 20px;
    height: auto;
}

.err-info {
    margin-top: 10px;
    display: flex;
    align-items: center;
}

.err-info img {
    width: 18px;
    height: auto;
    margin-right: 5px;
}

.cell {}
</style>
